import { FC, useEffect } from 'react';
import { publishBaseInfoEvent } from '@fe-core-events';
import { useSessionEnrollment } from '@hooks/mutations/useSessionEnrollment';
import { useIntl } from 'react-intl';
import { A11yButton } from '@fe-learner-common';

type JoinWaitlistButton = {
  sessionId: number;
};

export const JoinWaitlistButton: FC<JoinWaitlistButton> = ({ sessionId }) => {
  const intl = useIntl();

  const {
    mutate: enroll,
    isPending,
    isSuccess,
  } = useSessionEnrollment({
    sessionId,
  });

  useEffect(() => {
    if (isSuccess) {
      publishBaseInfoEvent({
        consumer: 'fe-learner-catalog',
        event: 'feedback.ui.info.base',
        type: 'modal',
        status: 'info',
        config: {
          title: intl.formatMessage({
            id: 'catalog.course.waitlist.confirmation.title',
          }),
          description: intl.formatMessage({
            id: 'catalog.course.waitlist.confirmation.description',
          }),
        },
        action: {
          event: '',
          type: 'close',
          text: { title: intl.formatMessage({ id: 'learner.common.close' }) },
        },
      });
    }
  }, [intl, isSuccess]);

  return (
    <A11yButton
      className="l-btn l-btn-md l-btn-primary"
      isLoading={isPending}
      onClick={() => {
        enroll();
      }}
    >
      {intl.formatMessage({ id: 'catalog.course.waitlist.join' })}
    </A11yButton>
  );
};
